import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const getFormattedDate = (_date) => {
  const date = dayjs(_date);
  // return full date if the date is older than 7 days old
  if (date.diff(Date.now(), 'day') < -7) {
    return dayjs(date).format('MMM DD, YYYY');
  }
  // return XX XX ago
  return dayjs(date).fromNow();
};

export default getFormattedDate;
